angular
    .module('advacedSelectSearch.components', [])
    .component('advacedSelectSearch', {
        templateUrl: 'ng/components/advacedSelectSearch/advacedSelectSearch.html',
        bindings: {
            options: '=',
            title: '@?',
            id: '@?'
        },
        controllerAs: 'advacedSelectSearchCtrl',
        controller: function () {

            var self = this; 

            self.$onInit = function () {
                self.options = self.options;
                console.log(self.options);
            }
        }
    });